import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function usePackageList() {
    const { t } = useI18nUtils()
    const isPackageFormSidebarActive = ref(false)
    const packageData = ref(null)
    const toast = useToast()
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const currentPage = ref(1)
    const searchQuery = ref('')
    const packages = ref([]);
    const statusFilter = ref(null)
    const totalPackages = ref(0)
    const refPackageListTable = ref(null)
    const contentsData = ref(null);
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'cover_image', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ]
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalPackages.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalPackages.value,
        }
    })

    // const updateGuidesOrdering = () => {
    //     const filteredData = guides.value?.filter(item => item !== undefined);

    //     store.dispatch('app-guides/updateGuidesOrdering', filteredData)
    // }

    const coverImage = (files) => {
        for(const file of files){
            if(file.is_feature) return file.path
        }
    }

    const resolvePackageStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolvePackageStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        fetchData()
    })

    const updatePackage = async (data) => {
        packageData.value = data
        
        isPackageFormSidebarActive.value = true
    }

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch(`app-packages/getPackageData`, {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'ordering_count DESC',
            sites_id: getLocalSite.id
        })
        .then(response => {
            packages.value = response.data.data
            totalPackages.value = response.data.total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Package' lists",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const deleteData = (id) => {
        store.dispatch('app-packages/deletePackageData', id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Package",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }
    const updateOrdering = () => {
            const filteredData = packages.value?.filter(item => item !== undefined);
    
            store.dispatch('app-packages/updateOrdering', filteredData)
        }
    return {
        isPackageFormSidebarActive,
        packageData,
        toast,
        perPage,
        perPageOptions,
        currentPage,
        searchQuery,
        packages,
        statusFilter,
        totalPackages,
        refPackageListTable,
        contentsData,
        getLocalSite,
        tableColumns,
        dataMeta,
        resolvePackageStatusVariant,
        resolvePackageStatusnameVariant,
        refetchData,
        updatePackage,
        fetchData,
        coverImage,
        t,
        deleteData,
        updateOrdering
    }
}